module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.9@core-js/library/modules/_add-to-unscopables.js
// module id = 95
// module chunks = 0